import { render, staticRenderFns } from "./ActivateUsers.vue?vue&type=template&id=ec037798"
import script from "./ActivateUsers.vue?vue&type=script&lang=js"
export * from "./ActivateUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports